import {
    addDays,
    addYears,
    formatDate,
    nbDaysBetweenTwoDates,
    now,
} from "../../../lib";
import {
    CommitementDetails,
    CommitmentRequirementDetails,
    establishementStatusEnum,
    Document,
    RolesEnum,
    TabMenu,
    DossierDetailType,
    DossierStatusEnum,
    EstablishmentStatus,
} from "../../../types";
import { dateFormat } from "../../../consts";
import { getValidatorDecision } from "./OverViews/utils";

export function getColorByPercent(value: number): string {
    if (!value) {
        return "#F43B00";
    }
    if (value === 100) {
        return "#3BD838";
    }
    if (value >= 0 && value <= 50) {
        return "#F43B00";
    }
    return "#FCB902";
}

export function getColorByEstablishmentStatus(
    establishmentStatusCode: string
): {
    border: string;
    background: string;
} {
    switch (establishmentStatusCode) {
        case establishementStatusEnum.CANDIDAT:
            return { border: "#FF900D", background: "#FFE9CF" };
        case establishementStatusEnum.NON_QUALIFIE:
            return { border: "#F43B00", background: "#FDD8CC" };
        case establishementStatusEnum.QUALIFIE:
            return { border: "#3BD838", background: "#D8F7D7" };
        default:
            return { border: "#FF900D", background: "#FFE9CF" };
    }
}

export function getColorByDossierStatus(dossierStatusCode: string): {
    border: string;
    background: string;
    status?: string;
} {
    switch (dossierStatusCode) {
        case DossierStatusEnum.ATTENTE_DECISION:
            return { border: "#0082DE", background: "#CCE6F8" };
        case DossierStatusEnum.FINALISE:
            return { border: "#3BD838", background: "#D8F7D7" };
        case establishementStatusEnum.QUALIFIE:
            return { border: "#3BD838", background: "#D8F7D7" };
        default:
            return { border: "#FF900D", background: "#FFE9CF" };
    }
}

export function _getColorByEstablishmentStatus(dossierStatusCode: string): {
    border: string;
    background: string;
} {
    switch (dossierStatusCode) {
        case establishementStatusEnum.CANDIDAT:
            return { border: "#0082DE", background: "#CCE6F8" };
        case establishementStatusEnum.NON_QUALIFIE:
            return { border: "#F43B00", background: "#FDD8CC" };
        case establishementStatusEnum.QUALIFIE:
            return { border: "#3BD838", background: "#D8F7D7" };
        default:
            return { border: "#FF900D", background: "#FFE9CF" };
    }
}

export function getTabsMenuByUserRole(userRoleId: number) {
    const tabsMenu: TabMenu[] = [
        {
            key: "eng",
            name: "Engagements",
        },
        {
            key: "audit",
            name: "Historique",
        },
    ];

    switch (userRoleId) {
        case RolesEnum.CLIENT:
            return tabsMenu;
        default:
            return tabsMenu.concat([
                {
                    key: "clientInfo",
                    name: "Infos adhérent",
                },
            ]);
    }
}

export const filterCompliantOrNotProcessedDocuments = (
    documents: Document[]
) => {
    if (!documents.length) {
        return documents;
    }
    return documents.filter(
        (d: Document) => d.compliant === true || d.compliant === null
        // (d.compliant === false && d.comment)
    );
};

// #########################  client spance

export const isCompletenessComReqs = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    const CompletedComReqs = commitmentRequirements.filter(
        (comReq: CommitmentRequirementDetails) => {
            return (
                comReq.documentQty ===
                filterCompliantOrNotProcessedDocuments(comReq.documents).length
            );
        }
    );
    return CompletedComReqs.length === commitmentRequirements.length;
};

export const computeCompletenessComReqs = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    return commitmentRequirements.filter(
        (comReq: CommitmentRequirementDetails) => {
            return (
                comReq.documentQty ===
                filterCompliantOrNotProcessedDocuments(comReq.documents).length
            );
        }
    );
};

export const computeCompletenessDocsInComReq = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    const CompletedComReqs = computeCompletenessComReqs(commitmentRequirements);
    return CompletedComReqs.length / commitmentRequirements.length;
};

export const computeCompletenessCommitments = (
    commitements: CommitementDetails[]
) => {
    return commitements.filter((com: CommitementDetails) => {
        if (!com.commitmentRequirements.length) {
            return false;
        }
        return isCompletenessComReqs(com.commitmentRequirements);
    });
};

export function computeLinearProgressValueOfCommitments(
    commitements: CommitementDetails[]
) {
    return (
        (computeCompletenessCommitments(commitements).length /
            commitements.length) *
        100
    );
}

// ################################  instruct

export const isInstructedDocuments = (documents: Document[]) => {
    if (!documents.length) {
        return documents;
    }
    return documents.filter(
        (d: Document) =>
            d.compliant === true || (d.compliant === false && d.comment)
    );
};

export const isInstructedComReqs = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    const instructedComReqs = commitmentRequirements.filter(
        (comReq: CommitmentRequirementDetails) => {
            return (
                comReq.documentQty ===
                isInstructedDocuments(comReq.documents).length
            );
        }
    );
    return instructedComReqs.length === commitmentRequirements.length;
};

export const calculateCommitmentsInstruction = (
    commitements: CommitementDetails[]
) =>
    commitements.filter((com: CommitementDetails) => {
        if (!com.commitmentRequirements.length) {
            return false;
        }
        return isInstructedComReqs(com.commitmentRequirements);
    });

export function computeLinearProgressValueOfInstruction(
    commitements: CommitementDetails[]
) {
    return Math.round(
        (calculateCommitmentsInstruction(commitements).length /
            commitements.length) *
            100
    );
}

export const computeInstructedComReqs = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    return commitmentRequirements.filter(
        (comReq: CommitmentRequirementDetails) => {
            return !comReq.documents.length
                ? false
                : isInstructedDocuments(comReq.documents).length ===
                      comReq.documents.length;
        }
    );
};

export const computeInstrcutedDocsInComReq = (
    commitmentRequirements: CommitmentRequirementDetails[]
) => {
    const instructedComReqs = computeInstructedComReqs(commitmentRequirements);
    if (instructedComReqs.length) {
        return instructedComReqs.length / commitmentRequirements.length;
    }
    return 0;
};

// #######################

export function buildInstructionInfos(
    dossierDetail: DossierDetailType,
    daysBeforeDeadline: number
) {
    const startInstructionDate = dossierDetail.processedAt
        ? dossierDetail.processedAt
        : dossierDetail.assignedAt;

    const instructionDeadlineDate =
        startInstructionDate && dossierDetail.instructionDeadlineAt
            ? dossierDetail.instructionDeadlineAt
            : "";

    const instructionInfos = {
        assignedDate: formatDate(startInstructionDate, dateFormat),
        instructionDeadline: formatDate(
            instructionDeadlineDate.toString(),
            dateFormat
        ),
        processStep: dossierDetail.processingStep,
    };
    const remainingNbDaysToInstruct = nbDaysBetweenTwoDates(
        instructionDeadlineDate.toString(),
        now().toString()
    );

    return {
        instructionInfos,
        remainingNbDaysToInstruct,
        instructionDeadlineDate,
    };
}

export const getLinearProgressLabelByUserRole = (userRoleId: number) => {
    switch (userRoleId) {
        case RolesEnum.ADMIN_RESEAU:
        case RolesEnum.ADMIN_REGION:
        case RolesEnum.CLIENT:
            return "Complétude des engagements";
        case RolesEnum.INSTRUCTEUR:
            return "Instruction des engagements";
        case RolesEnum.ADMIN:
            return "Instruction du dossier";
        default:
            return "";
    }
};

export const getCircularProgressLabelByUserRole = (userRoleId: number) => {
    switch (userRoleId) {
        case RolesEnum.ADMIN_RESEAU:
        case RolesEnum.ADMIN_REGION:
        case RolesEnum.CLIENT:
            return "Complétude de cet engagement";
        case RolesEnum.SYNERPA:
        case RolesEnum.ADMIN:
        case RolesEnum.INSTRUCTEUR:
            return "Instruction de cet engagement";
        default:
            return "";
    }
};

export const computeLinearProgressValue = (
    userRoleId: number,
    commitements: CommitementDetails[]
) => {
    if (!commitements.length) {
        return 0;
    }
    // if (userRoleId === RolesEnum.CLIENT) {
    //     return computeLinearProgressValueOfCommitments(commitements);
    // }

    if (
        [RolesEnum.INSTRUCTEUR, RolesEnum.ADMIN, RolesEnum.SYNERPA].includes(
            userRoleId
        )
    ) {
        return computeLinearProgressValueOfInstruction(commitements);
    }
    return 0;
};

export const filterNotCompliantDocuments = (documents: Document[]) => {
    const docsNotProcessed = documents.filter(
        (d) => d.compliant === false || (d.compliant === null && d.comment)
    );
    return docsNotProcessed;
};

export const filterCompliantDocuments = (documents: Document[]) => {
    const docsNotProcessed = documents.filter((d) => d.compliant === true);
    return docsNotProcessed;
};

//################################

export function getDossierStatusColorByUserRole(
    userRoleId: number,
    dossierDetail: DossierDetailType | null
) {
    if (!dossierDetail) {
        return { border: "#FF900D", background: "#FFE9CF" };
    }
    const dossierStatusCode = dossierDetail.dossierStatus.code;
    if (userRoleId === RolesEnum.SYNERPA) {
        if (dossierDetail.assignedValidatorUser) {
            if (dossierStatusCode === DossierStatusEnum.FINALISE)
                return {
                    border: "#3BD838",
                    background: "#D8F7D7",
                    status: "Finalisé",
                };
            return {
                border: "#FF900D",
                background: "#FFE9CF",
                status: "En cours d’examen",
            };
        }
        if (!dossierDetail.assignedValidatorUser) {
            return {
                border: "#C8CDD0",
                background: "#F3F5F6",
            };
        }
    }

    return getColorByDossierStatus(dossierStatusCode);
}

export const canShowDownloadCertificateBtn = (
    dossierDetail: DossierDetailType,
    establishmentStatus: EstablishmentStatus[]
) => {
    const validatorDecision = getValidatorDecision(
        dossierDetail,
        establishmentStatus
    );
    return validatorDecision?.code === establishementStatusEnum.QUALIFIE;
};

export function getValidatorDecisionInfos(dossierDetail: DossierDetailType) {
    const assignedValidatorDecisionAt =
        dossierDetail.assignedValidatorDecisionAt;
    if (assignedValidatorDecisionAt) {
        const expirationCertificateAt = addYears(
            assignedValidatorDecisionAt,
            1
        );

        return {
            assignedValidatorDecisionAt: formatDate(
                assignedValidatorDecisionAt,
                dateFormat
            ),
            expirationCertificateAt: formatDate(
                expirationCertificateAt.toString(),
                dateFormat
            ),
        };
    }
}
